import { nanoid } from '@reduxjs/toolkit';

const ARRAY_ITEM_PREFIX = 'ARRAY_ITEM_ID_';

/**
 * Функция для генерации Id элемента массива
 */
export function generateArrayItemId() {
    return ARRAY_ITEM_PREFIX + nanoid(7);
}

/**
 * Для проверки, является ли строка id элемента массива
 */
export function isArrayItemId(str: string) {
    return str.startsWith(ARRAY_ITEM_PREFIX);
}
